import { computed, ref, Ref } from 'vue';
import { ComplexModal } from '@studyportals/modal';
import store from '@/store';
import resetEnrolmentsPresenter from '@/presenters/reset-enrolments-presenter';
import EnrolmentPresenter from '@/presenters/enrolment-presenter';
import EnrolmentBatchSelector from '@/presenters/enrolment-batch-selector';
import { Enrolment } from '@/models/enrolment';
import RollbarOperator from '@/infrastructure/rollbar-operator';

export default class ResetEnrolmentsConfirmationModalComponent {
	public modalContent: Ref<HTMLElement | null> = ref(null);
	private modal: Ref<ComplexModal | undefined> = ref(undefined);
	
	public selectedEnrolmentsCount = computed((): number => {
		return this.selectedEnrolments.value.length;
	});

	private selectedEnrolments = computed((): Enrolment[] => {
		return store.getters.selectedEnrolments();
	});
	
	public mounted(): void {
		this.prepareModal();
	}

	public unmounted(): void {
		window.ModalManager.close(this.modal.value);
	}

	public async confirm(): Promise<void> {
		const identities = this.selectedEnrolments.value.map((enrolment) => enrolment.identity);
		const result = await resetEnrolmentsPresenter.resetEnrolments(identities);
		this.dismiss();
		if (!result || result.status === 'failure') {
			return;
		}
		if (result.status === 'partial_failure') {
			RollbarOperator.triggerWarning(`Some enrolments could not be reset: ${JSON.stringify({
				selectedEnrolmentIdentities: identities,
				totalSelectedEnrolments: identities.length,
				failedResets: result.failures,
				failedResetsCount: Array.isArray(result.failures) ? result.failures.length : 0
			})}`);
		}
		const batch = EnrolmentBatchSelector.selectEnrolmentsBatch();
		await EnrolmentPresenter.acquireEnrolments(batch);
	}

	public dismiss(): void {
		window.ModalManager.close(this.modal.value);
		resetEnrolmentsPresenter.isResetConfirmationShown.value = false;
	}

	private prepareModal(): void {
		if (!this.modalContent.value) {
			return;
		}

		this.modal.value = new ComplexModal(this.modalContent.value, {
			cssClassName: 'ResetEnrolmentsConfirmationModalWrapper',
			destroyOnClose: false,
			onClose: (): void => {
				resetEnrolmentsPresenter.isResetConfirmationShown.value = false;
			}
		});

		window.ModalManager.open(this.modal.value);
	}
}
